// Phase 3+4: Italian, French, Russian, Hindi, and Urdu completion overrides.
const phase34Completion = {
  "it": {
    "/notice/123 또는 https://...": "/notice/123 o https://...",
    "닉네임": "Nickname",
    "라운지 포인트 지급률 저장 실패": "Salvataggio del tasso di ricompensa punti lounge non riuscito",
    "레이크백": "Rakeback",
    "링크:": "Link:",
    "비밀번호": "Password",
    "아프리카": "Africa",
    "자산": "Asset",
    "인포카드 삭제": "Elimina scheda info",
    "인포카드 삭제 실패": "Eliminazione scheda info non riuscita",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "Eliminare questa scheda info? Verranno eliminate anche tutte le varianti desktop/mobile e per lingua della stessa scheda. Il gruppo tavolo e i tavoli di gioco non verranno eliminati.",
    "all / 데스크톱+모바일": "all / Desktop + Mobile",
    "desktop / 데스크톱": "desktop / Desktop",
    "mobile / 모바일": "mobile / Mobile",
    "대상": "Destinazione",
    "데스크톱": "Desktop",
    "모바일": "Mobile",
    "배치": "Batch",
    "아이디": "ID",
    "이메일": "Email",
    "에이전트 수수료 기본값 설정": "Impostazioni predefinite commissioni agente",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "Imposta le commissioni predefinite applicate alle registrazioni tramite referral e agli account figli creati automaticamente.",
    "현재 계정": "Account corrente",
    "현재 수수료": "Commissione corrente",
    "설정 상태": "Stato",
    "미설정": "Non configurato",
    "설정됨": "Configurato",
    "하위 에이전트 설정 방식": "Modalità di configurazione agente figlio",
    "자율형과 고정 설정 중 하나를 선택합니다.": "Scegli tra configurazione autonoma o fissa.",
    "자율형": "Autonoma",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "Assegna solo la commissione iniziale all'agente figlio diretto. L'agente decide poi le commissioni dei livelli inferiori.",
    "고정 설정": "Configurazione fissa",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "L'account corrente fissa tutte le commissioni degli agenti figli e degli utenti. Gli account figli non vedranno il popup di configurazione.",
    "직속 유저": "Utente diretto",
    "자율형 기본값": "Valori predefiniti autonomi",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "È la commissione iniziale applicata quando viene creato automaticamente un agente figlio diretto.",
    "lv{from} → lv{to} 기본 수수료": "lv{from} → lv{to} Commissione predefinita",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "L'agente figlio configurerà le commissioni dei livelli inferiori.",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4 non ha un livello agente inferiore, quindi viene configurato solo il valore predefinito per la registrazione utente.",
    "전체 고정 기본값": "Valori predefiniti fissi completi",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "I valori seguenti vengono applicati automaticamente in base al livello dell'account creato.",
    "lv{level} 고정 수수료": "Commissione fissa lv{level}",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "Applicata ai nodi agente lv{level} creati automaticamente.",
    "유저 고정 레이크백": "Rakeback utente fisso",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "Applicato a tutti i nuovi nodi utente creati sotto la catena fissa.",
    "고정 하위 경로 합계": "Totale percorso figli fisso",
    "유저 회원가입 타입": "Tipo di registrazione utente",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "Applicato quando un utente si registra direttamente tramite il codice referral dell'agente corrente.",
    "추천인 가입 유저 기본 수수료": "Commissione predefinita utente da referral",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "Mantenuta automaticamente uguale al valore utente fisso.",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "Applicato quando un utente è collegato direttamente sotto lv{level}.",
    "적용 방식": "Modalità di applicazione",
    "직접 가입 유저": "Utente registrato direttamente",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "Gli agenti figli soggetti a una politica fissa del superiore non vedono un popup separato per le impostazioni predefinite.",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "L'agente figlio può accedere e configurare separatamente i valori predefiniti del livello successivo.",
    "수수료 기본값 저장에 실패했습니다.": "Salvataggio dei valori predefiniti delle commissioni non riuscito.",
    "나중에 설정": "Configura più tardi",
    "기본값 저장": "Salva valori predefiniti",
    "직접 입력": "Inserimento manuale",
    "수수료 기본값 설정": "Imposta valori predefiniti commissioni",
    "수수료 기본값 수정": "Modifica valori predefiniti commissioni",
    "상위 고정 설정 적용 중": "Configurazione fissa superiore attiva",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "Inserisci un importo di almeno 0,01 con massimo due decimali.",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "Non puoi trasferire più del rakeback disponibile.",
    "레이크백을 일반 자산으로 이동했습니다.": "Il rakeback è stato trasferito al saldo degli asset generali.",
    "레이크백 이동에 실패했습니다.": "Trasferimento rakeback non riuscito.",
    "자산으로 이동": "Trasferisci agli asset",
    "레이크백 → 일반 자산": "Rakeback → Asset generali",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "L'importo trasferito viene detratto dal rakeback e aggiunto immediatamente agli asset generali.",
    "보유 레이크백": "Rakeback disponibile",
    "현재 일반 자산": "Asset generali correnti",
    "이동 금액": "Importo da trasferire",
    "전액": "Tutto",
    "이동 중...": "Trasferimento...",
    "소수 둘째 자리까지 입력 가능": "Fino a due decimali",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "Inserisci un importo da 0,01 a 1.000.000.000,00 con massimo due decimali.",
    "유저": "Utente",
    "디자인 이미지": "Immagine design",
    "디자인": "Design",
    "실제 비율 미리보기": "Anteprima rapporto reale",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "L'importo della voce di pagamento deve essere maggiore di 0 e avere al massimo due decimali.",
    "지급이 처리되지 않았습니다.": "L'accredito non è stato elaborato.",
    "차감이 처리되지 않았습니다.": "L'addebito non è stato elaborato.",
    "단독 인포버튼": "Pulsante info indipendente",
    "단독 인포버튼 생성 실패": "Creazione del pulsante info indipendente non riuscita",
    "+ 인포버튼 단독 생성": "+ Crea pulsante info indipendente",
    "인포버튼 단독 생성": "Crea pulsante info indipendente",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "Ripristinare il layout corrente e i testi multilingue ai valori predefiniti?",
    "이미지 파일만 업로드할 수 있습니다.": "È possibile caricare solo file immagine.",
    "배경 이미지 업로드에 실패했습니다.": "Caricamento dell'immagine di sfondo non riuscito.",
    "요소 이미지 업로드에 실패했습니다.": "Caricamento dell'immagine elemento non riuscito.",
    "이벤트 카드 디자인 · 광고 편집기 방식": "Design scheda evento · Modalità editor annunci",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "Modifica la scheda evento usando immagine di sfondo, posizionamento libero, elementi immagine e testo contrassegnato per lingua.",
    "기존 하이라이트 문구 불러오기": "Carica testo evidenziato esistente",
    "디자인 초기화": "Ripristina design",
    "새 디자인 사용": "Usa nuovo design",
    "편집 디바이스": "Dispositivo di modifica",
    "렌더링 방식": "Modalità di rendering",
    "배경 + HTML/CSS 요소": "Sfondo + elementi HTML/CSS",
    "이미지만 표시": "Solo immagine",
    "배경 이미지 맞춤": "Adattamento immagine di sfondo",
    "COVER · 영역 채우기": "COVER · Riempi area",
    "CONTAIN · 전체 표시": "CONTAIN · Mostra immagine intera",
    "FILL · 강제 맞춤": "FILL · Adatta forzatamente",
    "배경 이미지": "Immagine di sfondo",
    "업로드 중...": "Caricamento...",
    "로컬 이미지 업로드": "Carica immagine locale",
    "배경 제거": "Rimuovi sfondo",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "Il caricamento compila automaticamente /uploads/info-backgrounds/...",
    "요소 이미지 업로드 중...": "Caricamento immagine elemento...",
    "배경 이미지 미리보기": "Anteprima immagine di sfondo",
    "입력 내용이 미리보기에 자동 반영됨": "Le modifiche vengono riflesse automaticamente nell'anteprima.",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "Testo per lingua applicato · {count} lingue rilevate",
    "텍스트 {number}": "Testo {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "Ogni immagine elemento deve essere di 10 MB o meno.",
    "추가 텍스트": "Testo aggiuntivo",
    "요소 이미지": "Immagine elemento",
    "요소": "Elemento",
    "배너 레이아웃·다국어 편집": "Layout banner · Editor multilingue",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "Inserisci il testo multilingue di ogni elemento di testo in un unico campo e aggiungi immagini decorative locali separatamente dallo sfondo.",
    "클라이언트 언어별 미리보기": "Anteprima per lingua client",
    "미리보기: {language}": "Anteprima: {language}",
    "번역이 없을 때 사용할 언어": "Lingua di fallback quando manca una traduzione",
    "기본: {language}": "Predefinita: {language}",
    "편집 화면 {value}%": "Vista editor {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "Trascina gli elementi sulla tela ingrandita. Le coordinate vengono salvate come percentuali del banner, così si ridimensionano con la finestra all'interno dello stesso profilo dispositivo.",
    "텍스트 요소별 통합 다국어 입력": "Inserimento multilingue unificato per elemento di testo",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "Puoi usare ritorni a capo, | o virgole come separatori. Esempio: Korean:지금 바로 | English:Right now | Japanese:今すぐ",
    "언어별 찾아서 적용": "Rileva e applica per lingua",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "Korean:문구 | English:Text | Japanese:テキスト",
    "추가 텍스트 요소": "Elementi di testo aggiuntivi",
    "+ 텍스트 요소 추가": "+ Aggiungi elemento di testo",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "Nessun elemento di testo aggiuntivo. Aggiungine quanti ne servono.",
    "한국어:지금 바로 | 영어:Right now": "Korean:지금 바로 | English:Right now",
    "캔버스에서 이 텍스트 선택": "Seleziona questo testo sulla tela",
    "가로 중심": "Centro orizzontale",
    "세로 중심": "Centro verticale",
    "확대": "Scala",
    "이미지 투명도": "Opacità immagine",
    "텍스트 가독성 오버레이": "Overlay leggibilità testo",
    "요소 이미지 업로드": "Carica immagine elemento",
    "+ 로컬 이미지 추가": "+ Aggiungi immagine locale",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "Aggiungi più loghi, carte, chip, icone e altre immagini separatamente dallo sfondo, quindi regola posizione e dimensione di ciascuna.",
    "이미지 요소": "Elemento immagine",
    "기본 요소 선택": "Seleziona elemento base",
    "{element} 위치·크기": "{element} Posizione · Dimensione",
    "너비": "Larghezza",
    "높이": "Altezza",
    "기준 글자 크기": "Dimensione font base",
    "투명도": "Opacità",
    "회전": "Rotazione",
    "왼쪽": "Sinistra",
    "가운데": "Centro",
    "오른쪽": "Destra",
    "글자색": "Colore testo",
    "이미지 맞춤": "Adattamento immagine",
    "전체 표시 · contain": "Mostra immagine intera · contain",
    "영역 채우기 · cover": "Riempi area · cover",
    "강제 맞춤 · fill": "Adatta forzatamente · fill",
    "클라이언트에 표시": "Mostra sul client",
    "이 텍스트 요소 삭제": "Elimina questo elemento di testo",
    "이 이미지 요소 삭제": "Elimina questo elemento immagine",
    "프로필 좌표 복사": "Copia coordinate profilo",
    "{profile}에서 복사": "Copia da {profile}",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "Il link deve iniziare con http://, https:// oppure / per un percorso interno.",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · Ogni riga salvata è un annuncio separato.",
    "배너 렌더링 방식": "Modalità rendering banner",
    "배경 이미지 + 다국어 HTML/CSS 요소": "Immagine di sfondo + elementi HTML/CSS multilingue",
    "이미지 전체만 표시": "Mostra solo l'immagine intera",
    "이미지 전체 표시 · contain": "Mostra immagine intera · contain",
    "https://... 또는 /lounge": "https://... oppure /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "Lascia vuoto per non navigare · Sono supportati URL esterni o percorsi interni come /lounge.",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "In modalità immagine intera, l'immagine caricata viene mostrata così com'è. La modifica di coordinate ed elementi multilingue è disponibile in modalità Immagine di sfondo + HTML/CSS.",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "Ogni riga salvata è un annuncio separato · Gestito separatamente per area/device/country.",
    "배지": "Badge",
    "보상": "Ricompensa",
    "설명": "Descrizione",
    "버튼": "Pulsante",
    "배지 상단": "Parte superiore badge",
    "배지 하단": "Parte inferiore badge",
    "강조 제목": "Titolo evidenziato",
    "보상 문구": "Testo ricompensa"
  },
  "fr": {
    "+ 이미지": "+ Image",
    "/notice/123 또는 https://...": "/notice/123 ou https://...",
    "글로벌": "Global",
    "라운지 포인트 지급률 저장 실패": "Échec de l'enregistrement du taux de récompense des points lounge",
    "레이크백": "Rakeback",
    "에이전트": "Agent",
    "유럽": "Europe",
    "이미지": "Image",
    "이미지(URL)": "Image (URL)",
    "정상": "Normal",
    "총": "Total",
    "타입": "Type",
    "페이지": "Page",
    "인포카드 삭제": "Supprimer la carte d'information",
    "인포카드 삭제 실패": "Échec de la suppression de la carte d'information",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "Supprimer cette carte d'information ? Toutes les variantes desktop/mobile et linguistiques de la même carte seront également supprimées. Le groupe de tables et les tables de jeu ne seront pas supprimés.",
    "모바일": "Mobile",
    "직속": "Direct",
    "에이전트 수수료 기본값 설정": "Paramètres de commission par défaut de l'agent",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "Définissez les taux de commission par défaut appliqués aux inscriptions par parrainage et aux comptes enfants créés automatiquement.",
    "현재 계정": "Compte actuel",
    "현재 수수료": "Commission actuelle",
    "설정 상태": "État",
    "미설정": "Non configuré",
    "설정됨": "Configuré",
    "하위 에이전트 설정 방식": "Mode de configuration de l'agent enfant",
    "자율형과 고정 설정 중 하나를 선택합니다.": "Choisissez une configuration autonome ou fixe.",
    "자율형": "Autonome",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "Attribuez uniquement le taux initial à l'agent enfant direct. Cet agent décide ensuite des taux des niveaux inférieurs.",
    "고정 설정": "Configuration fixe",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "Le compte actuel fixe tous les taux des agents enfants et des utilisateurs. Les comptes enfants ne verront pas la fenêtre de configuration.",
    "직속 유저": "Utilisateur direct",
    "자율형 기본값": "Valeurs autonomes par défaut",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "Il s'agit du taux initial appliqué lors de la création automatique d'un agent enfant direct.",
    "lv{from} → lv{to} 기본 수수료": "lv{from} → lv{to} Commission par défaut",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "L'agent enfant configurera ensuite les taux des niveaux inférieurs.",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4 n'a pas de niveau d'agent inférieur ; seule la valeur par défaut d'inscription utilisateur est donc configurée.",
    "전체 고정 기본값": "Valeurs fixes complètes par défaut",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "Les valeurs ci-dessous sont appliquées automatiquement selon le niveau du compte créé.",
    "lv{level} 고정 수수료": "Commission fixe lv{level}",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "Appliquée aux nœuds d'agent lv{level} créés automatiquement.",
    "유저 고정 레이크백": "Rakeback utilisateur fixe",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "Appliqué à tous les nouveaux nœuds utilisateur créés sous la chaîne fixe.",
    "고정 하위 경로 합계": "Total du chemin enfant fixe",
    "유저 회원가입 타입": "Type d'inscription utilisateur",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "Appliqué lorsqu'un utilisateur s'inscrit directement via le code de parrainage de l'agent actuel.",
    "추천인 가입 유저 기본 수수료": "Commission utilisateur par défaut via parrainage",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "Maintenue automatiquement identique à la valeur utilisateur fixe.",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "Appliqué lorsqu'un utilisateur est connecté directement sous lv{level}.",
    "적용 방식": "Mode d'application",
    "직접 가입 유저": "Utilisateur inscrit directement",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "Les agents enfants soumis à une politique fixe du parent ne voient pas de fenêtre séparée de paramètres par défaut.",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "L'agent enfant peut se connecter et configurer séparément les valeurs par défaut du niveau suivant.",
    "수수료 기본값 저장에 실패했습니다.": "Échec de l'enregistrement des commissions par défaut.",
    "나중에 설정": "Configurer plus tard",
    "기본값 저장": "Enregistrer les valeurs par défaut",
    "직접 입력": "Saisie manuelle",
    "수수료 기본값 설정": "Définir les commissions par défaut",
    "수수료 기본값 수정": "Modifier les commissions par défaut",
    "상위 고정 설정 적용 중": "Configuration fixe du parent active",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "Saisissez un montant d'au moins 0,01 avec au maximum deux décimales.",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "Vous ne pouvez pas transférer plus que votre rakeback disponible.",
    "레이크백을 일반 자산으로 이동했습니다.": "Le rakeback a été transféré vers le solde des actifs généraux.",
    "레이크백 이동에 실패했습니다.": "Échec du transfert du rakeback.",
    "자산으로 이동": "Transférer vers les actifs",
    "레이크백 → 일반 자산": "Rakeback → Actifs généraux",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "Le montant transféré est déduit du rakeback et ajouté immédiatement aux actifs généraux.",
    "보유 레이크백": "Rakeback disponible",
    "현재 일반 자산": "Actifs généraux actuels",
    "이동 금액": "Montant du transfert",
    "전액": "Tout",
    "이동 중...": "Transfert en cours...",
    "소수 둘째 자리까지 입력 가능": "Jusqu'à deux décimales",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "Saisissez un montant compris entre 0,01 et 1 000 000 000,00 avec au maximum deux décimales.",
    "유저": "Utilisateur",
    "디자인 이미지": "Image de design",
    "디자인": "Design",
    "실제 비율 미리보기": "Aperçu du ratio réel",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "Le montant de l'élément de paiement doit être supérieur à 0 et comporter au maximum deux décimales.",
    "지급이 처리되지 않았습니다.": "Le crédit n'a pas été traité.",
    "차감이 처리되지 않았습니다.": "Le débit n'a pas été traité.",
    "단독 인포버튼": "Bouton d'information autonome",
    "단독 인포버튼 생성 실패": "Échec de la création du bouton d'information autonome",
    "+ 인포버튼 단독 생성": "+ Créer un bouton d'information autonome",
    "인포버튼 단독 생성": "Créer un bouton d'information autonome",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "Réinitialiser la disposition actuelle et les textes multilingues aux valeurs par défaut ?",
    "이미지 파일만 업로드할 수 있습니다.": "Seuls les fichiers image peuvent être téléversés.",
    "배경 이미지 업로드에 실패했습니다.": "Échec du téléversement de l'image d'arrière-plan.",
    "요소 이미지 업로드에 실패했습니다.": "Échec du téléversement de l'image de l'élément.",
    "이벤트 카드 디자인 · 광고 편집기 방식": "Design de carte d'événement · Mode éditeur d'annonces",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "Modifiez la carte d'événement avec une image d'arrière-plan, un positionnement libre, des éléments image et du texte balisé par langue.",
    "기존 하이라이트 문구 불러오기": "Charger le texte mis en avant existant",
    "디자인 초기화": "Réinitialiser le design",
    "새 디자인 사용": "Utiliser un nouveau design",
    "편집 디바이스": "Appareil d'édition",
    "렌더링 방식": "Mode de rendu",
    "배경 + HTML/CSS 요소": "Arrière-plan + éléments HTML/CSS",
    "이미지만 표시": "Image uniquement",
    "배경 이미지 맞춤": "Ajustement de l'image d'arrière-plan",
    "COVER · 영역 채우기": "COVER · Remplir la zone",
    "CONTAIN · 전체 표시": "CONTAIN · Afficher l'image entière",
    "FILL · 강제 맞춤": "FILL · Étirer pour ajuster",
    "배경 이미지": "Image d'arrière-plan",
    "업로드 중...": "Téléversement...",
    "로컬 이미지 업로드": "Téléverser une image locale",
    "배경 제거": "Supprimer l'arrière-plan",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "Le téléversement renseigne automatiquement /uploads/info-backgrounds/...",
    "요소 이미지 업로드 중...": "Téléversement de l'image de l'élément...",
    "배경 이미지 미리보기": "Aperçu de l'image d'arrière-plan",
    "입력 내용이 미리보기에 자동 반영됨": "Les modifications sont automatiquement reflétées dans l'aperçu.",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "Texte par langue appliqué · {count} langues détectées",
    "텍스트 {number}": "Texte {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "Chaque image d'élément doit faire 10 Mo ou moins.",
    "추가 텍스트": "Texte supplémentaire",
    "요소 이미지": "Image de l'élément",
    "요소": "Élément",
    "배너 레이아웃·다국어 편집": "Mise en page de bannière · Éditeur multilingue",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "Saisissez le texte multilingue de chaque élément de texte dans un seul champ et ajoutez des images décoratives locales séparément de l'arrière-plan.",
    "클라이언트 언어별 미리보기": "Aperçu par langue du client",
    "미리보기: {language}": "Aperçu : {language}",
    "번역이 없을 때 사용할 언어": "Langue de secours lorsqu'une traduction manque",
    "기본: {language}": "Par défaut : {language}",
    "편집 화면 {value}%": "Vue de l'éditeur {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "Faites glisser les éléments sur le canevas agrandi. Les coordonnées sont enregistrées en pourcentage de la bannière afin de suivre le redimensionnement de la fenêtre dans le même profil d'appareil.",
    "텍스트 요소별 통합 다국어 입력": "Saisie multilingue unifiée par élément de texte",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "Utilisez des retours à la ligne, | ou des virgules comme séparateurs. Exemple : Korean:지금 바로 | English:Right now | Japanese:今すぐ",
    "언어별 찾아서 적용": "Détecter et appliquer par langue",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "Korean:문구 | English:Text | Japanese:テキスト",
    "추가 텍스트 요소": "Éléments de texte supplémentaires",
    "+ 텍스트 요소 추가": "+ Ajouter un élément de texte",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "Aucun élément de texte supplémentaire. Ajoutez-en autant que nécessaire.",
    "한국어:지금 바로 | 영어:Right now": "Korean:지금 바로 | English:Right now",
    "캔버스에서 이 텍스트 선택": "Sélectionner ce texte sur le canevas",
    "가로 중심": "Centre horizontal",
    "세로 중심": "Centre vertical",
    "확대": "Échelle",
    "이미지 투명도": "Opacité de l'image",
    "텍스트 가독성 오버레이": "Superposition de lisibilité du texte",
    "요소 이미지 업로드": "Téléverser l'image de l'élément",
    "+ 로컬 이미지 추가": "+ Ajouter une image locale",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "Ajoutez plusieurs logos, cartes, jetons, icônes et autres images séparément de l'arrière-plan, puis ajustez la position et la taille de chacun.",
    "이미지 요소": "Élément image",
    "기본 요소 선택": "Sélectionner l'élément de base",
    "{element} 위치·크기": "{element} Position · Taille",
    "너비": "Largeur",
    "높이": "Hauteur",
    "기준 글자 크기": "Taille de police de base",
    "투명도": "Opacité",
    "회전": "Rotation",
    "왼쪽": "Gauche",
    "가운데": "Centre",
    "오른쪽": "Droite",
    "글자색": "Couleur du texte",
    "이미지 맞춤": "Ajustement de l'image",
    "전체 표시 · contain": "Afficher l'image entière · contain",
    "영역 채우기 · cover": "Remplir la zone · cover",
    "강제 맞춤 · fill": "Étirer pour ajuster · fill",
    "클라이언트에 표시": "Afficher sur le client",
    "이 텍스트 요소 삭제": "Supprimer cet élément de texte",
    "이 이미지 요소 삭제": "Supprimer cet élément image",
    "프로필 좌표 복사": "Copier les coordonnées du profil",
    "{profile}에서 복사": "Copier depuis {profile}",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "Le lien doit commencer par http://, https:// ou / pour un chemin interne.",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · Chaque ligne enregistrée correspond à une annonce distincte.",
    "배너 렌더링 방식": "Mode de rendu de la bannière",
    "배경 이미지 + 다국어 HTML/CSS 요소": "Image d'arrière-plan + éléments HTML/CSS multilingues",
    "이미지 전체만 표시": "Afficher uniquement l'image entière",
    "이미지 전체 표시 · contain": "Afficher l'image entière · contain",
    "https://... 또는 /lounge": "https://... ou /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "Laissez vide pour ne pas naviguer · Les URL externes et les chemins internes comme /lounge sont pris en charge.",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "En mode image entière, l'image téléversée est affichée telle quelle. L'édition des coordonnées et des éléments multilingues est disponible en mode Image d'arrière-plan + HTML/CSS.",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "Chaque ligne enregistrée correspond à une annonce distincte · Gérée séparément par area/device/country.",
    "배지": "Badge",
    "보상": "Récompense",
    "설명": "Description",
    "버튼": "Bouton",
    "배지 상단": "Haut du badge",
    "배지 하단": "Bas du badge",
    "강조 제목": "Titre mis en avant",
    "보상 문구": "Texte de récompense"
  },
  "ru": {
    "/notice/123 또는 https://...": "/notice/123 или https://...",
    "인포카드": "Инфокарта",
    "인포카드 삭제": "Удалить инфокарту",
    "인포카드 삭제 실패": "Не удалось удалить инфокарту",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "Удалить эту инфокарту? Все desktop/mobile и языковые варианты этой карты также будут удалены. Группа столов и игровые столы удалены не будут.",
    "에이전트 수수료 기본값 설정": "Настройки комиссий агента по умолчанию",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "Задайте ставки комиссий по умолчанию для регистраций по реферальному коду и автоматически создаваемых дочерних аккаунтов.",
    "현재 계정": "Текущий аккаунт",
    "현재 수수료": "Текущая комиссия",
    "설정 상태": "Статус",
    "미설정": "Не настроено",
    "설정됨": "Настроено",
    "하위 에이전트 설정 방식": "Режим настройки дочернего агента",
    "자율형과 고정 설정 중 하나를 선택합니다.": "Выберите автономную или фиксированную настройку.",
    "자율형": "Автономная",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "Назначьте прямому дочернему агенту только начальную ставку. Дальнейшие ставки ниже по структуре он определяет самостоятельно.",
    "고정 설정": "Фиксированная настройка",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "Текущий аккаунт фиксирует все ставки дочерних агентов и пользователей. Дочерние аккаунты не увидят окно настройки.",
    "직속 유저": "Прямой пользователь",
    "자율형 기본값": "Автономные значения по умолчанию",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "Это начальная ставка, применяемая при автоматическом создании прямого дочернего агента.",
    "lv{from} → lv{to} 기본 수수료": "lv{from} → lv{to} Комиссия по умолчанию",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "Дочерний агент сам настроит ставки ниже по своей структуре.",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "У lv4 нет нижнего уровня агентов, поэтому настраивается только значение по умолчанию для регистрации пользователя.",
    "전체 고정 기본값": "Полные фиксированные значения по умолчанию",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "Значения ниже применяются автоматически в зависимости от уровня создаваемого аккаунта.",
    "lv{level} 고정 수수료": "Фиксированная комиссия lv{level}",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "Применяется к автоматически создаваемым узлам агентов lv{level}.",
    "유저 고정 레이크백": "Фиксированный рейкбек пользователя",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "Применяется ко всем новым пользовательским узлам, создаваемым под фиксированной цепочкой.",
    "고정 하위 경로 합계": "Итого по фиксированному дочернему пути",
    "유저 회원가입 타입": "Тип регистрации пользователя",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "Применяется, когда пользователь регистрируется напрямую по реферальному коду текущего агента.",
    "추천인 가입 유저 기본 수수료": "Комиссия по умолчанию для пользователя по рефералу",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "Автоматически поддерживается равной фиксированному значению пользователя.",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "Применяется, когда пользователь подключён напрямую под lv{level}.",
    "적용 방식": "Режим применения",
    "직접 가입 유저": "Пользователь с прямой регистрацией",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "Дочерние агенты, на которых действует фиксированная политика родителя, не видят отдельное окно настроек по умолчанию.",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "Дочерний агент может войти в аккаунт и отдельно настроить значения по умолчанию для следующего уровня.",
    "수수료 기본값 저장에 실패했습니다.": "Не удалось сохранить комиссии по умолчанию.",
    "나중에 설정": "Настроить позже",
    "기본값 저장": "Сохранить значения по умолчанию",
    "직접 입력": "Ручной ввод",
    "수수료 기본값 설정": "Задать комиссии по умолчанию",
    "수수료 기본값 수정": "Изменить комиссии по умолчанию",
    "상위 고정 설정 적용 중": "Активна фиксированная настройка родителя",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "Введите сумму не менее 0,01 с точностью до двух знаков после запятой.",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "Нельзя перевести больше доступного рейкбека.",
    "레이크백을 일반 자산으로 이동했습니다.": "Рейкбек переведён на баланс общих активов.",
    "레이크백 이동에 실패했습니다.": "Не удалось перевести рейкбек.",
    "자산으로 이동": "Перевести в активы",
    "레이크백 → 일반 자산": "Рейкбек → Общие активы",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "Переведённая сумма вычитается из рейкбека и сразу добавляется к общим активам.",
    "보유 레이크백": "Доступный рейкбек",
    "현재 일반 자산": "Текущие общие активы",
    "이동 금액": "Сумма перевода",
    "전액": "Всё",
    "이동 중...": "Перевод...",
    "소수 둘째 자리까지 입력 가능": "До двух знаков после запятой",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "Введите сумму от 0,01 до 1 000 000 000,00 с точностью до двух знаков после запятой.",
    "유저": "Пользователь",
    "디자인 이미지": "Изображение дизайна",
    "디자인": "Дизайн",
    "실제 비율 미리보기": "Предпросмотр фактического соотношения",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "Сумма платёжной позиции должна быть больше 0 и содержать не более двух знаков после запятой.",
    "지급이 처리되지 않았습니다.": "Зачисление не было обработано.",
    "차감이 처리되지 않았습니다.": "Списание не было обработано.",
    "단독 인포버튼": "Отдельная инфокнопка",
    "단독 인포버튼 생성 실패": "Не удалось создать отдельную инфокнопку",
    "+ 인포버튼 단독 생성": "+ Создать отдельную инфокнопку",
    "인포버튼 단독 생성": "Создать отдельную инфокнопку",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "Сбросить текущую компоновку и многоязычные тексты к значениям по умолчанию?",
    "이미지 파일만 업로드할 수 있습니다.": "Можно загружать только файлы изображений.",
    "배경 이미지 업로드에 실패했습니다.": "Не удалось загрузить фоновое изображение.",
    "요소 이미지 업로드에 실패했습니다.": "Не удалось загрузить изображение элемента.",
    "이벤트 카드 디자인 · 광고 편집기 방식": "Дизайн карточки события · Режим редактора рекламы",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "Редактируйте карточку события с помощью фонового изображения, свободного позиционирования, изображений элементов и текста с языковыми метками.",
    "기존 하이라이트 문구 불러오기": "Загрузить существующий выделенный текст",
    "디자인 초기화": "Сбросить дизайн",
    "새 디자인 사용": "Использовать новый дизайн",
    "편집 디바이스": "Устройство редактирования",
    "렌더링 방식": "Режим рендеринга",
    "배경 + HTML/CSS 요소": "Фон + элементы HTML/CSS",
    "이미지만 표시": "Только изображение",
    "배경 이미지 맞춤": "Подгонка фонового изображения",
    "COVER · 영역 채우기": "COVER · Заполнить область",
    "CONTAIN · 전체 표시": "CONTAIN · Показать изображение целиком",
    "FILL · 강제 맞춤": "FILL · Растянуть по размеру",
    "배경 이미지": "Фоновое изображение",
    "업로드 중...": "Загрузка...",
    "로컬 이미지 업로드": "Загрузить локальное изображение",
    "배경 제거": "Удалить фон",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "После загрузки /uploads/info-backgrounds/... заполняется автоматически.",
    "요소 이미지 업로드 중...": "Загрузка изображения элемента...",
    "배경 이미지 미리보기": "Предпросмотр фонового изображения",
    "입력 내용이 미리보기에 자동 반영됨": "Изменения автоматически отражаются в предпросмотре.",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "Текст по языкам применён · обнаружено языков: {count}",
    "텍스트 {number}": "Текст {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "Размер каждого изображения элемента должен быть не более 10 МБ.",
    "추가 텍스트": "Дополнительный текст",
    "요소 이미지": "Изображение элемента",
    "요소": "Элемент",
    "배너 레이아웃·다국어 편집": "Макет баннера · Многоязычный редактор",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "Введите многоязычный текст каждого текстового элемента в одном поле и добавляйте локальные декоративные изображения отдельно от фона.",
    "클라이언트 언어별 미리보기": "Предпросмотр по языку клиента",
    "미리보기: {language}": "Предпросмотр: {language}",
    "번역이 없을 때 사용할 언어": "Резервный язык при отсутствии перевода",
    "기본: {language}": "По умолчанию: {language}",
    "편집 화면 {value}%": "Масштаб редактора {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "Перетаскивайте элементы на увеличенном холсте. Координаты сохраняются в процентах от баннера, поэтому масштабируются вместе с окном в пределах одного профиля устройства.",
    "텍스트 요소별 통합 다국어 입력": "Единый многоязычный ввод для текстового элемента",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "В качестве разделителей можно использовать переносы строк, | или запятые. Пример: Korean:지금 바로 | English:Right now | Japanese:今すぐ",
    "언어별 찾아서 적용": "Определить и применить по языку",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "Korean:문구 | English:Text | Japanese:テキスト",
    "추가 텍스트 요소": "Дополнительные текстовые элементы",
    "+ 텍스트 요소 추가": "+ Добавить текстовый элемент",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "Дополнительных текстовых элементов нет. Добавьте столько, сколько нужно.",
    "한국어:지금 바로 | 영어:Right now": "Korean:지금 바로 | English:Right now",
    "캔버스에서 이 텍스트 선택": "Выбрать этот текст на холсте",
    "가로 중심": "По центру горизонтально",
    "세로 중심": "По центру вертикально",
    "확대": "Масштаб",
    "이미지 투명도": "Непрозрачность изображения",
    "텍스트 가독성 오버레이": "Оверлей для читаемости текста",
    "요소 이미지 업로드": "Загрузить изображение элемента",
    "+ 로컬 이미지 추가": "+ Добавить локальное изображение",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "Добавляйте несколько логотипов, карт, фишек, иконок и других изображений отдельно от фона и настраивайте позицию и размер каждого.",
    "이미지 요소": "Элемент изображения",
    "기본 요소 선택": "Выбрать базовый элемент",
    "{element} 위치·크기": "{element} Позиция · Размер",
    "너비": "Ширина",
    "높이": "Высота",
    "기준 글자 크기": "Базовый размер шрифта",
    "투명도": "Непрозрачность",
    "회전": "Поворот",
    "왼쪽": "Слева",
    "가운데": "По центру",
    "오른쪽": "Справа",
    "글자색": "Цвет текста",
    "이미지 맞춤": "Подгонка изображения",
    "전체 표시 · contain": "Показать изображение целиком · contain",
    "영역 채우기 · cover": "Заполнить область · cover",
    "강제 맞춤 · fill": "Растянуть по размеру · fill",
    "클라이언트에 표시": "Показывать в клиенте",
    "이 텍스트 요소 삭제": "Удалить этот текстовый элемент",
    "이 이미지 요소 삭제": "Удалить этот элемент изображения",
    "프로필 좌표 복사": "Копировать координаты профиля",
    "{profile}에서 복사": "Копировать из {profile}",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "Ссылка должна начинаться с http://, https:// или / для внутреннего пути.",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · Каждая сохранённая строка — отдельная реклама.",
    "배너 렌더링 방식": "Режим рендеринга баннера",
    "배경 이미지 + 다국어 HTML/CSS 요소": "Фоновое изображение + многоязычные элементы HTML/CSS",
    "이미지 전체만 표시": "Показывать только изображение целиком",
    "이미지 전체 표시 · contain": "Показать изображение целиком · contain",
    "https://... 또는 /lounge": "https://... или /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "Оставьте пустым, чтобы переход не выполнялся · Поддерживаются внешние URL и внутренние пути, например /lounge.",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "В режиме полного изображения загруженная картинка отображается как есть. Редактирование координат и многоязычных элементов доступно в режиме Фоновое изображение + HTML/CSS.",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "Каждая сохранённая строка — отдельная реклама · Управляется отдельно по area/device/country.",
    "배지": "Бейдж",
    "보상": "Награда",
    "설명": "Описание",
    "버튼": "Кнопка",
    "배지 상단": "Верх бейджа",
    "배지 하단": "Низ бейджа",
    "강조 제목": "Акцентный заголовок",
    "보상 문구": "Текст награды"
  },
  "hi": {
    "/notice/123 또는 https://...": "/notice/123 या https://...",
    "라운지 포인트 지급률 저장 실패": "लाउंज पॉइंट रिवॉर्ड दर सहेजने में विफल",
    "인포카드 삭제": "इन्फो कार्ड हटाएँ",
    "인포카드 삭제 실패": "इन्फो कार्ड हटाने में विफल",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "क्या यह इन्फो कार्ड हटाएँ? इसी कार्ड के सभी desktop/mobile और भाषा वेरिएंट भी हट जाएँगे। टेबल समूह और गेम टेबल नहीं हटाए जाएँगे।",
    "에이전트 수수료 기본값 설정": "एजेंट डिफ़ॉल्ट शुल्क सेटिंग्स",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "रेफ़रल साइनअप और स्वतः बनाए गए चाइल्ड खातों पर लागू होने वाली डिफ़ॉल्ट शुल्क दरें सेट करें।",
    "현재 계정": "वर्तमान खाता",
    "현재 수수료": "वर्तमान शुल्क",
    "설정 상태": "स्थिति",
    "미설정": "कॉन्फ़िगर नहीं किया गया",
    "설정됨": "कॉन्फ़िगर किया गया",
    "하위 에이전트 설정 방식": "चाइल्ड एजेंट सेटअप मोड",
    "자율형과 고정 설정 중 하나를 선택합니다.": "स्वायत्त या फिक्स्ड सेटअप में से एक चुनें।",
    "자율형": "स्वायत्त",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "सीधे चाइल्ड एजेंट को केवल प्रारंभिक दर दें। उसके नीचे की दरें वही एजेंट तय करेगा।",
    "고정 설정": "फिक्स्ड सेटअप",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "वर्तमान खाता सभी चाइल्ड एजेंट और यूज़र दरें फिक्स करता है। चाइल्ड खातों को सेटअप पॉपअप दिखाई नहीं देगा।",
    "직속 유저": "सीधा यूज़र",
    "자율형 기본값": "स्वायत्त डिफ़ॉल्ट",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "यह वह प्रारंभिक दर है जो सीधे चाइल्ड एजेंट के स्वतः बनने पर लागू होती है।",
    "lv{from} → lv{to} 기본 수수료": "lv{from} → lv{to} डिफ़ॉल्ट शुल्क",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "चाइल्ड एजेंट अपने नीचे की दरें स्वयं कॉन्फ़िगर करेगा।",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4 के नीचे कोई और एजेंट स्तर नहीं है, इसलिए केवल यूज़र साइनअप डिफ़ॉल्ट कॉन्फ़िगर होता है।",
    "전체 고정 기본값": "पूर्ण फिक्स्ड डिफ़ॉल्ट",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "नीचे दिए गए मान बनाए गए खाते के स्तर के अनुसार स्वतः लागू होते हैं।",
    "lv{level} 고정 수수료": "lv{level} फिक्स्ड शुल्क",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "स्वतः बनाए गए lv{level} एजेंट नोड्स पर लागू।",
    "유저 고정 레이크백": "फिक्स्ड यूज़र रेकबैक",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "फिक्स्ड चेन के नीचे बनाए गए सभी नए यूज़र नोड्स पर लागू।",
    "고정 하위 경로 합계": "फिक्स्ड चाइल्ड-पाथ कुल",
    "유저 회원가입 타입": "यूज़र साइनअप प्रकार",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "जब कोई यूज़र वर्तमान एजेंट के रेफ़रल कोड से सीधे साइनअप करता है तब लागू।",
    "추천인 가입 유저 기본 수수료": "रेफ़रल साइनअप यूज़र डिफ़ॉल्ट शुल्क",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "फिक्स्ड यूज़र मान के बराबर स्वतः बनाए रखा जाता है।",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "जब यूज़र सीधे lv{level} के नीचे जुड़ता है तब लागू।",
    "적용 방식": "लागू करने का मोड",
    "직접 가입 유저": "सीधा साइनअप यूज़र",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "पैरेंट की फिक्स्ड नीति के अधीन चाइल्ड एजेंट को अलग डिफ़ॉल्ट-सेटिंग्स पॉपअप नहीं दिखता।",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "चाइल्ड एजेंट लॉग इन करके अगले स्तर के डिफ़ॉल्ट अलग से कॉन्फ़िगर कर सकता है।",
    "수수료 기본값 저장에 실패했습니다.": "डिफ़ॉल्ट शुल्क सहेजने में विफल।",
    "나중에 설정": "बाद में सेट करें",
    "기본값 저장": "डिफ़ॉल्ट सहेजें",
    "직접 입력": "मैनुअल इनपुट",
    "수수료 기본값 설정": "डिफ़ॉल्ट शुल्क सेट करें",
    "수수료 기본값 수정": "डिफ़ॉल्ट शुल्क संपादित करें",
    "상위 고정 설정 적용 중": "पैरेंट फिक्स्ड सेटअप सक्रिय",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "कम से कम 0.01 की राशि अधिकतम दो दशमलव स्थानों तक दर्ज करें।",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "आप उपलब्ध रेकबैक से अधिक ट्रांसफ़र नहीं कर सकते।",
    "레이크백을 일반 자산으로 이동했습니다.": "रेकबैक सामान्य एसेट बैलेंस में ट्रांसफ़र कर दिया गया है।",
    "레이크백 이동에 실패했습니다.": "रेकबैक ट्रांसफ़र करने में विफल।",
    "자산으로 이동": "एसेट में ट्रांसफ़र करें",
    "레이크백 → 일반 자산": "रेकबैक → सामान्य एसेट",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "ट्रांसफ़र की गई राशि रेकबैक से घटती है और तुरंत सामान्य एसेट में जुड़ जाती है।",
    "보유 레이크백": "उपलब्ध रेकबैक",
    "현재 일반 자산": "वर्तमान सामान्य एसेट",
    "이동 금액": "ट्रांसफ़र राशि",
    "전액": "सभी",
    "이동 중...": "ट्रांसफ़र हो रहा है...",
    "소수 둘째 자리까지 입력 가능": "अधिकतम दो दशमलव स्थान",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "0.01 से 1,000,000,000.00 तक की राशि अधिकतम दो दशमलव स्थानों तक दर्ज करें।",
    "유저": "यूज़र",
    "디자인 이미지": "डिज़ाइन इमेज",
    "디자인": "डिज़ाइन",
    "실제 비율 미리보기": "वास्तविक अनुपात पूर्वावलोकन",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "पेमेंट आइटम राशि 0 से अधिक होनी चाहिए और अधिकतम दो दशमलव स्थान तक हो सकती है।",
    "지급이 처리되지 않았습니다.": "क्रेडिट प्रोसेस नहीं हुआ।",
    "차감이 처리되지 않았습니다.": "डेबिट प्रोसेस नहीं हुआ।",
    "단독 인포버튼": "स्टैंडअलोन इन्फो बटन",
    "단독 인포버튼 생성 실패": "स्टैंडअलोन इन्फो बटन बनाने में विफल",
    "+ 인포버튼 단독 생성": "+ स्टैंडअलोन इन्फो बटन बनाएँ",
    "인포버튼 단독 생성": "स्टैंडअलोन इन्फो बटन बनाएँ",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "क्या वर्तमान लेआउट और बहुभाषी टेक्स्ट को डिफ़ॉल्ट पर रीसेट करें?",
    "이미지 파일만 업로드할 수 있습니다.": "केवल इमेज फ़ाइलें अपलोड की जा सकती हैं।",
    "배경 이미지 업로드에 실패했습니다.": "बैकग्राउंड इमेज अपलोड करने में विफल।",
    "요소 이미지 업로드에 실패했습니다.": "एलिमेंट इमेज अपलोड करने में विफल।",
    "이벤트 카드 디자인 · 광고 편집기 방식": "इवेंट कार्ड डिज़ाइन · ऐड एडिटर मोड",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "इवेंट कार्ड को बैकग्राउंड इमेज, फ्री पोज़िशनिंग, इमेज एलिमेंट और भाषा-टैग वाले टेक्स्ट के साथ संपादित करें।",
    "기존 하이라이트 문구 불러오기": "मौजूदा हाइलाइट टेक्स्ट लोड करें",
    "디자인 초기화": "डिज़ाइन रीसेट करें",
    "새 디자인 사용": "नया डिज़ाइन उपयोग करें",
    "편집 디바이스": "एडिटिंग डिवाइस",
    "렌더링 방식": "रेंडरिंग मोड",
    "배경 + HTML/CSS 요소": "बैकग्राउंड + HTML/CSS एलिमेंट",
    "이미지만 표시": "केवल इमेज",
    "배경 이미지 맞춤": "बैकग्राउंड इमेज फ़िट",
    "COVER · 영역 채우기": "COVER · क्षेत्र भरें",
    "CONTAIN · 전체 표시": "CONTAIN · पूरी इमेज दिखाएँ",
    "FILL · 강제 맞춤": "FILL · खींचकर फ़िट करें",
    "배경 이미지": "बैकग्राउंड इमेज",
    "업로드 중...": "अपलोड हो रहा है...",
    "로컬 이미지 업로드": "लोकल इमेज अपलोड करें",
    "배경 제거": "बैकग्राउंड हटाएँ",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "अपलोड करने पर /uploads/info-backgrounds/... स्वतः भर जाता है।",
    "요소 이미지 업로드 중...": "एलिमेंट इमेज अपलोड हो रही है...",
    "배경 이미지 미리보기": "बैकग्राउंड इमेज पूर्वावलोकन",
    "입력 내용이 미리보기에 자동 반영됨": "परिवर्तन पूर्वावलोकन में स्वतः दिखाई देते हैं।",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "भाषा टेक्स्ट लागू · {count} भाषाएँ मिलीं",
    "텍스트 {number}": "टेक्स्ट {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "हर एलिमेंट इमेज 10 MB या उससे कम होनी चाहिए।",
    "추가 텍스트": "अतिरिक्त टेक्स्ट",
    "요소 이미지": "एलिमेंट इमेज",
    "요소": "एलिमेंट",
    "배너 레이아웃·다국어 편집": "बैनर लेआउट · बहुभाषी एडिटर",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "हर टेक्स्ट एलिमेंट के बहुभाषी टेक्स्ट को एक ही फ़ील्ड में दर्ज करें और बैकग्राउंड से अलग लोकल सजावटी इमेज जोड़ें।",
    "클라이언트 언어별 미리보기": "क्लाइंट भाषा के अनुसार पूर्वावलोकन",
    "미리보기: {language}": "पूर्वावलोकन: {language}",
    "번역이 없을 때 사용할 언어": "अनुवाद न होने पर उपयोग की जाने वाली फ़ॉलबैक भाषा",
    "기본: {language}": "डिफ़ॉल्ट: {language}",
    "편집 화면 {value}%": "एडिटर व्यू {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "बढ़े हुए कैनवास पर एलिमेंट खींचकर रखें। निर्देशांक बैनर प्रतिशत के रूप में सहेजे जाते हैं, इसलिए वे उसी डिवाइस प्रोफ़ाइल में विंडो के साथ स्केल होते हैं।",
    "텍스트 요소별 통합 다국어 입력": "टेक्स्ट एलिमेंट के अनुसार एकीकृत बहुभाषी इनपुट",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "सेपरेटर के रूप में लाइन ब्रेक, | या कॉमा उपयोग कर सकते हैं। उदाहरण: Korean:지금 바로 | English:Right now | Japanese:今すぐ",
    "언어별 찾아서 적용": "भाषा पहचानें और लागू करें",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "Korean:문구 | English:Text | Japanese:テキスト",
    "추가 텍스트 요소": "अतिरिक्त टेक्स्ट एलिमेंट",
    "+ 텍스트 요소 추가": "+ टेक्स्ट एलिमेंट जोड़ें",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "कोई अतिरिक्त टेक्स्ट एलिमेंट नहीं है। आवश्यकता अनुसार जोड़ें।",
    "한국어:지금 바로 | 영어:Right now": "Korean:지금 바로 | English:Right now",
    "캔버스에서 이 텍스트 선택": "कैनवास पर यह टेक्स्ट चुनें",
    "가로 중심": "क्षैतिज केंद्र",
    "세로 중심": "ऊर्ध्वाधर केंद्र",
    "확대": "स्केल",
    "이미지 투명도": "इमेज अपारदर्शिता",
    "텍스트 가독성 오버레이": "टेक्स्ट पठनीयता ओवरले",
    "요소 이미지 업로드": "एलिमेंट इमेज अपलोड",
    "+ 로컬 이미지 추가": "+ लोकल इमेज जोड़ें",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "बैकग्राउंड से अलग कई लोगो, कार्ड, चिप, आइकन और अन्य इमेज जोड़ें और हर एक की स्थिति व आकार समायोजित करें।",
    "이미지 요소": "इमेज एलिमेंट",
    "기본 요소 선택": "बेस एलिमेंट चुनें",
    "{element} 위치·크기": "{element} स्थिति · आकार",
    "너비": "चौड़ाई",
    "높이": "ऊँचाई",
    "기준 글자 크기": "बेस फ़ॉन्ट आकार",
    "투명도": "अपारदर्शिता",
    "회전": "रोटेशन",
    "왼쪽": "बाएँ",
    "가운데": "केंद्र",
    "오른쪽": "दाएँ",
    "글자색": "टेक्स्ट रंग",
    "이미지 맞춤": "इमेज फ़िट",
    "전체 표시 · contain": "पूरी इमेज दिखाएँ · contain",
    "영역 채우기 · cover": "क्षेत्र भरें · cover",
    "강제 맞춤 · fill": "खींचकर फ़िट करें · fill",
    "클라이언트에 표시": "क्लाइंट पर दिखाएँ",
    "이 텍스트 요소 삭제": "यह टेक्स्ट एलिमेंट हटाएँ",
    "이 이미지 요소 삭제": "यह इमेज एलिमेंट हटाएँ",
    "프로필 좌표 복사": "प्रोफ़ाइल निर्देशांक कॉपी करें",
    "{profile}에서 복사": "{profile} से कॉपी करें",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "आंतरिक पाथ के लिए लिंक http://, https:// या / से शुरू होना चाहिए।",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · हर सहेजी गई row एक अलग विज्ञापन है।",
    "배너 렌더링 방식": "बैनर रेंडरिंग मोड",
    "배경 이미지 + 다국어 HTML/CSS 요소": "बैकग्राउंड इमेज + बहुभाषी HTML/CSS एलिमेंट",
    "이미지 전체만 표시": "केवल पूरी इमेज दिखाएँ",
    "이미지 전체 표시 · contain": "पूरी इमेज दिखाएँ · contain",
    "https://... 또는 /lounge": "https://... या /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "नेविगेशन न करने के लिए खाली छोड़ें · बाहरी URL या /lounge जैसे आंतरिक पाथ समर्थित हैं।",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "फुल-इमेज मोड में अपलोड की गई इमेज जैसी है वैसी दिखती है। निर्देशांक और बहुभाषी एलिमेंट संपादन बैकग्राउंड इमेज + HTML/CSS मोड में उपलब्ध है।",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "हर सहेजी गई row एक अलग विज्ञापन है · area/device/country के अनुसार अलग प्रबंधित।",
    "배지": "बैज",
    "보상": "इनाम",
    "설명": "विवरण",
    "버튼": "बटन",
    "배지 상단": "बैज ऊपर",
    "배지 하단": "बैज नीचे",
    "강조 제목": "हाइलाइट शीर्षक",
    "보상 문구": "इनाम टेक्स्ट"
  },
  "ur": {
    "/notice/123 또는 https://...": "/notice/123 یا https://...",
    "라운지 포인트 지급률 저장 실패": "لاؤنج پوائنٹ ریوارڈ ریٹ محفوظ کرنے میں ناکامی",
    "인포카드 삭제": "انفو کارڈ حذف کریں",
    "인포카드 삭제 실패": "انفو کارڈ حذف کرنے میں ناکامی",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "کیا یہ انفو کارڈ حذف کرنا ہے؟ اسی کارڈ کے تمام desktop/mobile اور زبان کے ورژنز بھی حذف ہو جائیں گے۔ ٹیبل گروپ اور گیم ٹیبل حذف نہیں ہوں گے۔",
    "에이전트 수수료 기본값 설정": "ایجنٹ ڈیفالٹ فیس سیٹنگز",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "ریفرل سائن اپ اور خودکار طور پر بننے والے چائلڈ اکاؤنٹس پر لاگو ہونے والی ڈیفالٹ فیس ریٹس مقرر کریں۔",
    "현재 계정": "موجودہ اکاؤنٹ",
    "현재 수수료": "موجودہ فیس",
    "설정 상태": "حالت",
    "미설정": "کنفیگر نہیں کیا گیا",
    "설정됨": "کنفیگر کیا گیا",
    "하위 에이전트 설정 방식": "چائلڈ ایجنٹ سیٹ اپ موڈ",
    "자율형과 고정 설정 중 하나를 선택합니다.": "خودمختار یا فکسڈ سیٹ اپ میں سے ایک منتخب کریں۔",
    "자율형": "خودمختار",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "براہ راست چائلڈ ایجنٹ کو صرف ابتدائی ریٹ دیں۔ اس کے نیچے کی ریٹس وہ ایجنٹ خود طے کرے گا۔",
    "고정 설정": "فکسڈ سیٹ اپ",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "موجودہ اکاؤنٹ تمام چائلڈ ایجنٹ اور یوزر ریٹس فکس کرتا ہے۔ چائلڈ اکاؤنٹس کو سیٹ اپ پاپ اپ نظر نہیں آئے گا۔",
    "직속 유저": "براہ راست یوزر",
    "자율형 기본값": "خودمختار ڈیفالٹس",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "یہ وہ ابتدائی ریٹ ہے جو براہ راست چائلڈ ایجنٹ کے خودکار طور پر بننے پر لاگو ہوتا ہے۔",
    "lv{from} → lv{to} 기본 수수료": "lv{from} → lv{to} ڈیفالٹ فیس",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "چائلڈ ایجنٹ اپنے نیچے کی ریٹس خود کنفیگر کرے گا۔",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4 کے نیچے مزید ایجنٹ لیول نہیں ہے، اس لیے صرف یوزر سائن اپ ڈیفالٹ کنفیگر ہوتا ہے۔",
    "전체 고정 기본값": "مکمل فکسڈ ڈیفالٹس",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "نیچے دی گئی قدریں بنائے گئے اکاؤنٹ کے لیول کے مطابق خودکار طور پر لاگو ہوتی ہیں۔",
    "lv{level} 고정 수수료": "lv{level} فکسڈ فیس",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "خودکار طور پر بننے والے lv{level} ایجنٹ نوڈز پر لاگو۔",
    "유저 고정 레이크백": "فکسڈ یوزر ریک بیک",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "فکسڈ چین کے نیچے بننے والے تمام نئے یوزر نوڈز پر لاگو۔",
    "고정 하위 경로 합계": "فکسڈ چائلڈ پاتھ کل",
    "유저 회원가입 타입": "یوزر سائن اپ قسم",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "جب کوئی یوزر موجودہ ایجنٹ کے ریفرل کوڈ سے براہ راست سائن اپ کرے تو لاگو ہوتا ہے۔",
    "추천인 가입 유저 기본 수수료": "ریفرل سائن اپ یوزر ڈیفالٹ فیس",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "فکسڈ یوزر ویلیو کے برابر خودکار طور پر برقرار رکھی جاتی ہے۔",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "جب یوزر براہ راست lv{level} کے نیچے منسلک ہو تو لاگو ہوتا ہے۔",
    "적용 방식": "اطلاق کا موڈ",
    "직접 가입 유저": "براہ راست سائن اپ یوزر",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "پیرنٹ کی فکسڈ پالیسی کے تحت چائلڈ ایجنٹس کو الگ ڈیفالٹ سیٹنگز پاپ اپ نظر نہیں آتا۔",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "چائلڈ ایجنٹ لاگ ان کر کے اگلے لیول کے ڈیفالٹس الگ سے کنفیگر کر سکتا ہے۔",
    "수수료 기본값 저장에 실패했습니다.": "ڈیفالٹ فیس محفوظ کرنے میں ناکامی۔",
    "나중에 설정": "بعد میں سیٹ کریں",
    "기본값 저장": "ڈیفالٹس محفوظ کریں",
    "직접 입력": "دستی ان پٹ",
    "수수료 기본값 설정": "ڈیفالٹ فیس سیٹ کریں",
    "수수료 기본값 수정": "ڈیفالٹ فیس میں ترمیم کریں",
    "상위 고정 설정 적용 중": "پیرنٹ فکسڈ سیٹ اپ فعال",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "کم از کم 0.01 کی رقم دو اعشاری مقامات تک درج کریں۔",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "آپ دستیاب ریک بیک سے زیادہ منتقل نہیں کر سکتے۔",
    "레이크백을 일반 자산으로 이동했습니다.": "ریک بیک عمومی اثاثہ بیلنس میں منتقل کر دیا گیا ہے۔",
    "레이크백 이동에 실패했습니다.": "ریک بیک منتقل کرنے میں ناکامی۔",
    "자산으로 이동": "اثاثوں میں منتقل کریں",
    "레이크백 → 일반 자산": "ریک بیک → عمومی اثاثے",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "منتقل شدہ رقم ریک بیک سے منہا ہو کر فوراً عمومی اثاثوں میں شامل ہو جاتی ہے۔",
    "보유 레이크백": "دستیاب ریک بیک",
    "현재 일반 자산": "موجودہ عمومی اثاثے",
    "이동 금액": "منتقلی کی رقم",
    "전액": "سب",
    "이동 중...": "منتقل ہو رہا ہے...",
    "소수 둘째 자리까지 입력 가능": "دو اعشاری مقامات تک",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "0.01 سے 1,000,000,000.00 تک رقم دو اعشاری مقامات تک درج کریں۔",
    "유저": "یوزر",
    "디자인 이미지": "ڈیزائن امیج",
    "디자인": "ڈیزائن",
    "실제 비율 미리보기": "اصل تناسب کا پیش منظر",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "ادائیگی آئٹم کی رقم 0 سے زیادہ اور زیادہ سے زیادہ دو اعشاری مقامات تک ہونی چاہیے۔",
    "지급이 처리되지 않았습니다.": "کریڈٹ پراسیس نہیں ہوا۔",
    "차감이 처리되지 않았습니다.": "ڈیبٹ پراسیس نہیں ہوا۔",
    "단독 인포버튼": "اسٹینڈ الون انفو بٹن",
    "단독 인포버튼 생성 실패": "اسٹینڈ الون انفو بٹن بنانے میں ناکامی",
    "+ 인포버튼 단독 생성": "+ اسٹینڈ الون انفو بٹن بنائیں",
    "인포버튼 단독 생성": "اسٹینڈ الون انفو بٹن بنائیں",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "کیا موجودہ لے آؤٹ اور کثیر لسانی متن کو ڈیفالٹس پر ری سیٹ کرنا ہے؟",
    "이미지 파일만 업로드할 수 있습니다.": "صرف امیج فائلیں اپ لوڈ کی جا سکتی ہیں۔",
    "배경 이미지 업로드에 실패했습니다.": "بیک گراؤنڈ امیج اپ لوڈ کرنے میں ناکامی۔",
    "요소 이미지 업로드에 실패했습니다.": "ایلیمنٹ امیج اپ لوڈ کرنے میں ناکامی۔",
    "이벤트 카드 디자인 · 광고 편집기 방식": "ایونٹ کارڈ ڈیزائن · اشتہار ایڈیٹر موڈ",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "ایونٹ کارڈ کو بیک گراؤنڈ امیج، آزاد پوزیشننگ، امیج ایلیمنٹس اور زبان کے ٹیگ والے متن کے ذریعے ایڈٹ کریں۔",
    "기존 하이라이트 문구 불러오기": "موجودہ ہائی لائٹ متن لوڈ کریں",
    "디자인 초기화": "ڈیزائن ری سیٹ کریں",
    "새 디자인 사용": "نیا ڈیزائن استعمال کریں",
    "편집 디바이스": "ایڈیٹنگ ڈیوائس",
    "렌더링 방식": "رینڈرنگ موڈ",
    "배경 + HTML/CSS 요소": "بیک گراؤنڈ + HTML/CSS ایلیمنٹس",
    "이미지만 표시": "صرف امیج",
    "배경 이미지 맞춤": "بیک گراؤنڈ امیج فِٹ",
    "COVER · 영역 채우기": "COVER · علاقہ بھریں",
    "CONTAIN · 전체 표시": "CONTAIN · مکمل امیج دکھائیں",
    "FILL · 강제 맞춤": "FILL · کھینچ کر فِٹ کریں",
    "배경 이미지": "بیک گراؤنڈ امیج",
    "업로드 중...": "اپ لوڈ ہو رہا ہے...",
    "로컬 이미지 업로드": "لوکل امیج اپ لوڈ کریں",
    "배경 제거": "بیک گراؤنڈ ہٹائیں",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "اپ لوڈ کرنے پر /uploads/info-backgrounds/... خودکار طور پر بھر جاتا ہے۔",
    "요소 이미지 업로드 중...": "ایلیمنٹ امیج اپ لوڈ ہو رہی ہے...",
    "배경 이미지 미리보기": "بیک گراؤنڈ امیج پیش منظر",
    "입력 내용이 미리보기에 자동 반영됨": "تبدیلیاں خودکار طور پر پیش منظر میں ظاہر ہوتی ہیں۔",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "زبان کے مطابق متن لاگو · {count} زبانیں دریافت ہوئیں",
    "텍스트 {number}": "متن {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "ہر ایلیمنٹ امیج 10 MB یا اس سے کم ہونی چاہیے۔",
    "추가 텍스트": "اضافی متن",
    "요소 이미지": "ایلیمنٹ امیج",
    "요소": "ایلیمنٹ",
    "배너 레이아웃·다국어 편집": "بینر لے آؤٹ · کثیر لسانی ایڈیٹر",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "ہر ٹیکسٹ ایلیمنٹ کا کثیر لسانی متن ایک ہی فیلڈ میں درج کریں اور بیک گراؤنڈ سے الگ لوکل آرائشی امیجز شامل کریں۔",
    "클라이언트 언어별 미리보기": "کلائنٹ زبان کے مطابق پیش منظر",
    "미리보기: {language}": "پیش منظر: {language}",
    "번역이 없을 때 사용할 언어": "ترجمہ نہ ہونے پر استعمال ہونے والی فال بیک زبان",
    "기본: {language}": "ڈیفالٹ: {language}",
    "편집 화면 {value}%": "ایڈیٹر ویو {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "بڑے کینوس پر ایلیمنٹس کو گھسیٹ کر رکھیں۔ کوآرڈینیٹس بینر فیصد کے طور پر محفوظ ہوتے ہیں، اس لیے ایک ہی ڈیوائس پروفائل میں ونڈو کے ساتھ اسکیل ہوتے ہیں۔",
    "텍스트 요소별 통합 다국어 입력": "ٹیکسٹ ایلیمنٹ کے مطابق متحد کثیر لسانی ان پٹ",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "سیپریٹر کے طور پر لائن بریک، | یا کوما استعمال کیے جا سکتے ہیں۔ مثال: Korean:지금 바로 | English:Right now | Japanese:今すぐ",
    "언어별 찾아서 적용": "زبان شناخت کریں اور لاگو کریں",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "Korean:문구 | English:Text | Japanese:テキスト",
    "추가 텍스트 요소": "اضافی ٹیکسٹ ایلیمنٹس",
    "+ 텍스트 요소 추가": "+ ٹیکسٹ ایلیمنٹ شامل کریں",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "کوئی اضافی ٹیکسٹ ایلیمنٹ نہیں۔ ضرورت کے مطابق شامل کریں۔",
    "한국어:지금 바로 | 영어:Right now": "Korean:지금 바로 | English:Right now",
    "캔버스에서 이 텍스트 선택": "کینوس پر یہ متن منتخب کریں",
    "가로 중심": "افقی مرکز",
    "세로 중심": "عمودی مرکز",
    "확대": "اسکیل",
    "이미지 투명도": "امیج اوپیسٹی",
    "텍스트 가독성 오버레이": "متن کی پڑھنے کی صلاحیت کا اوورلے",
    "요소 이미지 업로드": "ایلیمنٹ امیج اپ لوڈ",
    "+ 로컬 이미지 추가": "+ لوکل امیج شامل کریں",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "بیک گراؤنڈ سے الگ کئی لوگو، کارڈ، چپس، آئیکنز اور دیگر امیجز شامل کریں اور ہر ایک کی پوزیشن اور سائز ایڈجسٹ کریں۔",
    "이미지 요소": "امیج ایلیمنٹ",
    "기본 요소 선택": "بیس ایلیمنٹ منتخب کریں",
    "{element} 위치·크기": "{element} پوزیشن · سائز",
    "너비": "چوڑائی",
    "높이": "اونچائی",
    "기준 글자 크기": "بیس فونٹ سائز",
    "투명도": "اوپیسٹی",
    "회전": "روٹیشن",
    "왼쪽": "بائیں",
    "가운데": "مرکز",
    "오른쪽": "دائیں",
    "글자색": "متن کا رنگ",
    "이미지 맞춤": "امیج فِٹ",
    "전체 표시 · contain": "مکمل امیج دکھائیں · contain",
    "영역 채우기 · cover": "علاقہ بھریں · cover",
    "강제 맞춤 · fill": "کھینچ کر فِٹ کریں · fill",
    "클라이언트에 표시": "کلائنٹ پر دکھائیں",
    "이 텍스트 요소 삭제": "یہ ٹیکسٹ ایلیمنٹ حذف کریں",
    "이 이미지 요소 삭제": "یہ امیج ایلیمنٹ حذف کریں",
    "프로필 좌표 복사": "پروفائل کوآرڈینیٹس کاپی کریں",
    "{profile}에서 복사": "{profile} سے کاپی کریں",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "اندرونی پاتھ کے لیے لنک http://، https:// یا / سے شروع ہونا چاہیے۔",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · ہر محفوظ row ایک الگ اشتہار ہے۔",
    "배너 렌더링 방식": "بینر رینڈرنگ موڈ",
    "배경 이미지 + 다국어 HTML/CSS 요소": "بیک گراؤنڈ امیج + کثیر لسانی HTML/CSS ایلیمنٹس",
    "이미지 전체만 표시": "صرف مکمل امیج دکھائیں",
    "이미지 전체 표시 · contain": "مکمل امیج دکھائیں · contain",
    "https://... 또는 /lounge": "https://... یا /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "نیویگیشن نہ کرنے کے لیے خالی چھوڑیں · بیرونی URL یا /lounge جیسے اندرونی پاتھ سپورٹ ہیں۔",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "فل امیج موڈ میں اپ لوڈ کی گئی امیج جوں کی توں دکھائی جاتی ہے۔ کوآرڈینیٹس اور کثیر لسانی ایلیمنٹ ایڈیٹنگ بیک گراؤنڈ امیج + HTML/CSS موڈ میں دستیاب ہے۔",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "ہر محفوظ row ایک الگ اشتہار ہے · area/device/country کے مطابق الگ منظم کیا جاتا ہے۔",
    "배지": "بیج",
    "보상": "انعام",
    "설명": "تفصیل",
    "버튼": "بٹن",
    "배지 상단": "بیج اوپر",
    "배지 하단": "بیج نیچے",
    "강조 제목": "نمایاں عنوان",
    "보상 문구": "انعامی متن"
  }
};

export default phase34Completion;
